import { Button, Modal } from "@veneer/core";

export const ModalMessageUser = ({
  setOpenCloseModal,
  closeModalCreateUser,
  openModal,
  titleMessage,
  message,
}: any) => {
  return (
    <Modal
      align="start"
      id="modal-id"
      show={openModal}
      onClose={() => setOpenCloseModal(false)}
      footer={<Button onClick={closeModalCreateUser}>Ok</Button>}
      title={titleMessage}
    >
      <p>{message}</p>
    </Modal>
  );
};
